<template>
  <div class="bg-white border-radius-5 border-box feed-item q-mb-xs">
    <q-item
      dense
      exact
      :to="feedLink"
      class="q-pa-none max-width-324"
      clickable
      v-ripple
    >
      <q-item-section class="full-height q-pa-md">
        <div class="col-auto">
          <div class="col-12 q-pb-xs">
            <div class="row items-center">
              <div class="col datetimeLabel text-bold ellipsis-3-lines q-pr-sm">
                {{ documentTypeName }}
              </div>

              <div class="col-auto datetimeLabel">
                {{ datetime }}
              </div>
            </div>
          </div>
        </div>

        <div class="col full-width">
          <div class="row full-height">
            <div class="col">
              <div
                class="column full-width full-height justify-between"
                style="word-break: break-all"
              >
                <div class="col-auto titleLabel ellipsis-2-lines">
                  {{ subTitle }}
                </div>

                <div class="col-auto titleLabel ellipsis-3-lines">
                  {{ scheduleTitle }}
                </div>

                <div
                  v-if="agencyLabel"
                  class="col-auto datetimeLabel ellipsis"
                >
                  {{ agencyLabel }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </q-item-section>
    </q-item>
  </div>
</template>

<script>
import moment from '@/components/moment'
import { attachView } from '@/aws/api'
import { genUrl } from '@/components/documents'

const ignoreSubTypes = [392]

export default {
  props: {
    id: {},
    thumb: {},
    image: {},
    numeration: {},
    scheduleAt: {},
    materialDate: {},
    scheduleTitle: {},
    agencyLabel: {},
    documentTypeId: {},
    documentTypeName: {},
    documentSubTypeName: {}
  },

  data () {
    return {
      imageUrl: null
    }
  },

  mounted () {
    this.loadImageURL()
  },

  computed: {
    feedLink () {
      const { documentTypeName, id } = this
      return genUrl({ documentTypeName, id }, false)
    },

    datetime () {
      return moment.unix(this.scheduleAt).format('DD/MM HH:mm')
    },

    subTitle () {
      let subTitle = ''
      const concat = (label) => (subTitle = (subTitle ? `${subTitle} - ` : '').concat(label))
      const canSetSubType = !ignoreSubTypes.includes(this.documentTypeId) && this.documentSubTypeName
      if (canSetSubType) concat(this.documentSubTypeName)
      if (this.numeration) concat(`Nº ${String(this.numeration).padStart(4, '0')}/${moment.unix(this.materialDate).format('YYYY')}`)
      return subTitle
    }
  },

  methods: {
    loadImageURL () {
      if (this.thumb) return this.setImageURL(this.thumb)

      const isEmpty = !this.image?.id && !this.image?.url
      if (isEmpty) return this.clearImageURL()

      attachView(this.image)
        .then(this.setImageURL)
        .catch(this.clearImageURL)
    },

    setImageURL (imageUrl) {
      this.imageUrl = imageUrl
    },

    clearImageURL () {
      this.setImageURL(null)
    }
  }
}
</script>

<style lang="sass">
  .feed-item
    .datetimeLabel
      color: #000000
      font-size: 12px

    .max-width-324
      max-width: 324px

    .titleLabel
      color: #000000
      font-size: 14px
      line-height: 1.3em !important
</style>
